import { useState } from 'react';
import { Download, Share, ChevronRight, X } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

// A More-screen row that offers PWA installation. Renders nothing when already installed, or
// when there's nothing to offer (e.g. desktop Safari/Firefox, or Android before Chrome fires
// beforeinstallprompt). On Android/desktop Chrome it triggers the native install prompt; on
// iOS (no prompt API) it opens manual Add-to-Home-Screen instructions.
export function InstallAppRow() {
  const { isStandalone, isIOS, canPrompt, promptInstall } = useInstallPrompt();
  const [showIosHelp, setShowIosHelp] = useState(false);

  if (isStandalone) return null;
  if (!canPrompt && !isIOS) return null;

  const handleClick = () => {
    if (canPrompt) promptInstall();
    else setShowIosHelp(true);
  };

  return (
    <>
      <section className="mt-5">
        <div className="bg-card rounded-2xl shadow-sm overflow-hidden">
          <button
            onClick={handleClick}
            className="w-full flex items-center gap-3 px-4 py-4 hover:bg-gray-50 transition-colors"
          >
            <div className="w-10 h-10 rounded-full bg-[var(--primary-light)] flex items-center justify-center flex-shrink-0">
              <Download className="w-5 h-5 text-[var(--link-ingredient)]" />
            </div>
            <div className="flex-1 text-left">
              <div className="text-foreground">Install app</div>
              <div className="text-sm text-muted-foreground">Add MealPlan Genie to your home screen</div>
            </div>
            <ChevronRight className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>
      </section>

      {showIosHelp && (
        <div
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40"
          onClick={() => setShowIosHelp(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Install on iPhone or iPad"
        >
          <div
            className="bg-white w-full sm:max-w-sm rounded-t-2xl sm:rounded-2xl p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-medium">Install on iPhone / iPad</h3>
              <button onClick={() => setShowIosHelp(false)} aria-label="Close">
                <X className="w-5 h-5 text-muted-foreground" />
              </button>
            </div>
            <ol className="space-y-3 text-sm text-foreground">
              <li className="flex items-center gap-2">
                <span>1. In Safari, tap the</span>
                <Share className="w-4 h-4 inline-block" aria-hidden="true" />
                <span><strong>Share</strong> button.</span>
              </li>
              <li>2. Scroll down and tap <strong>Add to Home Screen</strong>.</li>
              <li>3. Tap <strong>Add</strong> — MealPlan Genie appears on your home screen.</li>
            </ol>
            <button
              onClick={() => setShowIosHelp(false)}
              className="mt-6 w-full py-2.5 rounded-full bg-primary text-primary-foreground"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
}
